import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_FORM_STATE,
} from './constants';

const initialState = fromJS({
  form: {
    whatExpensesAreYouClaimingFor: [],
    lostStolenOrDamagedItemsItems: [],
    cashItems: [],
    baggageDelayItems: [],
    hasLuggageBeenReturned: null,
    dateWhenLuggageWasReturned: null,
    wasLostOrDamagedByAirline: null,
    numberOfCheckedBags: '',
    baggageCheckNumbers: '',
    dateBaggageCheckIssued: null,
    dateLossReportedToAirline: null,
    dateClaimedWithAirline: null,
    lostOrDamagedAirlineItems: [],
    wasLostOrDamagedSomewhereElse: null,
    descriptionBaggageLostOrDamaged: '',
    otherLossOrDamageItems: [],
    descriptionBaggageStolen: '',
    authorityReportedTheft: '',
    stolenBaggageItems: [],
    dateBaggageSupposedToArrive: null,
    timeBaggageSupposedToArrive: null,
    dateBaggageActuallyArrived: null,
    timeBaggageActuallyArrived: null,
    hasReceivedAirlineRefund: null,
    airlineRefundAmount: '',
    airlineRefundCurrency: '',
  },
  errors: [],
});

function handleFormReset(state, { fields }) {
  let newState = state;
  fields.forEach((field) => {
    const defaultValue = initialState.getIn(['form', field]);
    newState = newState.setIn(['form', field], defaultValue);
  });
  return newState;
}

function baggageAndPersonalItemsTravellerTugoReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload ? fromJS({ form: action.payload, errors: [] }) : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_FORM_STATE:
      return handleFormReset(state, action.payload);
    default:
      return state;
  }
}

export default baggageAndPersonalItemsTravellerTugoReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.BaggageAndPersonalItemsTraveller/reducer.js